module.exports = __webpack_public_path__ + "img/icon2.e895e61d.png";